import React, { useContext, useEffect } from 'react';
import {
  Tooltip,
  Input,
  Avatar,
  Select,
  Dropdown,
  Menu,
  Divider,
  Message,
  Button,
} from '@arco-design/web-react';
import {
  IconLanguage,
  IconNotification,
  IconSunFill,
  IconMoonFill,
  IconUser,
  IconSettings,
  IconPoweroff,
  IconExperiment,
  IconDashboard,
  IconInteraction,
  IconTag,
  IconLoading,
  IconEdit,
  IconBook,
  IconBug,
} from '@arco-design/web-react/icon';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalState } from '@/store';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import MessageBox from '@/components/MessageBox';
import IconButton from './IconButton';
import Settings from '../Settings';
import styles from './style/index.module.less';
import defaultLocale from '@/locale';
import useStorage from '@/utils/useStorage';
import { generatePermission } from '@/routes';
import { logout } from '@/utils/checkLogin';
import { useHistory } from 'react-router-dom';
import Logo from '@/assets/logo.svg';

function Navbar({ show }: { show: boolean }) {
  const t = useLocale();
  const { userInfo, userLoading } = useSelector((state: GlobalState) => state);
  const dispatch = useDispatch();
  const history = useHistory();

  const [_, setUserStatus] = useStorage('userStatus');
  const [role, setRole] = useStorage('userRole', 'admin');

  const { setLang, lang, theme, setTheme } = useContext(GlobalContext);

  async function handleLogout() {
    try {
      // 调用登出接口并清除本地存储
      await logout();
      Message.success('登出成功');
      // 重定向到登录页
      window.location.href = '/login';
    } catch (error) {
      Message.error('登出失败，请重试');
      console.error('登出失败:', error);
    }
  }

  function onMenuItemClick(key) {
    if (key === 'logout') {
      handleLogout();
    } else if (key === 'setting') {
      window.location.href = '/user/setting';
    }
  }

  useEffect(() => {
    dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: {
          ...userInfo,
          permissions: generatePermission(role),
        },
      },
    });
  }, [role]);

  if (!show) {
    return (
      <div className={styles['fixed-settings']}>
        <Settings
          trigger={
            <Button icon={<IconSettings />} type="primary" size="large" />
          }
        />
      </div>
    );
  }

  const handleChangeRole = () => {
    const newRole = role === 'admin' ? 'user' : 'admin';
    setRole(newRole);
  };

  const droplist = (
    <Menu onClickMenuItem={onMenuItemClick}>
      <Menu.Item key="setting">
        <IconSettings className={styles['dropdown-icon']} />
        {t['menu.user.setting']}
      </Menu.Item>
      <Divider style={{ margin: '4px 0' }} />
      <Menu.Item key="logout">
        <IconPoweroff className={styles['dropdown-icon']} />
        {t['navbar.logout']}
      </Menu.Item>
    </Menu>
  );

  // 获取用户头像URL（确保包含API前缀）
  const avatarUrl = userInfo.avatar;

  return (
    <div className={styles.navbar}>
      <div className={styles.left}>
        <a
          href="https://www.suwendata.com/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.logo}
          style={{
            cursor: 'pointer',
            transition: 'opacity 0.3s',
            opacity: 1,
            textDecoration: 'none',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.8')}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
        >
          <Logo />
          <div className={styles['logo-name']}>
            {/* 速问 */}
            <sup
              style={{
                fontSize: '10px',
                color: theme === 'dark' ? '#B37FEB' : '#722ED1',
                fontWeight: 'normal',
                background:
                  theme === 'dark'
                    ? 'rgba(179, 127, 235, 0.15)'
                    : 'rgba(114, 46, 209, 0.1)',
                padding: '0 4px',
                borderRadius: '4px',
              }}
            >
              Beta
            </sup>
          </div>
        </a>
      </div>
      <ul className={styles.right}>
        {/* <li>
          <Input.Search
            className={styles.round}
            placeholder={t['navbar.search.placeholder']}
          />
        </li> */}
        {/* 语言切换组件已隐藏
        <li>
          <Select
            triggerElement={<IconButton icon={<IconLanguage />} />}
            options={[
              { label: '中文', value: 'zh-CN' },
              { label: 'English', value: 'en-US' },
            ]}
            value={lang}
            triggerProps={{
              autoAlignPopupWidth: false,
              autoAlignPopupMinWidth: true,
              position: 'br',
            }}
            trigger="hover"
            onChange={(value) => {
              setLang(value);
              const nextLang = defaultLocale[value];
              Message.info(`${nextLang['message.lang.tips']}${value}`);
            }}
          />
        </li>
        */}
        {/* <li>
          <MessageBox>
            <IconButton icon={<IconNotification />} />
          </MessageBox>
        </li> */}
        {/* <li>
          <Tooltip
            content={
              theme === 'light'
                ? t['settings.navbar.theme.toDark']
                : t['settings.navbar.theme.toLight']
            }
          >
            <IconButton
              icon={theme !== 'dark' ? <IconMoonFill /> : <IconSunFill />}
              onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
            />
          </Tooltip>
        </li> */}
        {/* <Settings /> */}
        <li>
          <Tooltip content="内容纠错反馈">
            <IconButton
              icon={<IconBug />}
              onClick={() =>
                window.open(
                  'https://slan-tech.feishu.cn/share/base/form/shrcnPnjTCTWxOpaRSp0l0B0vph',
                  '_blank'
                )
              }
            />
          </Tooltip>
        </li>
        <li>
          <Tooltip content="速问知识库">
            <IconButton
              icon={<IconBook />}
              onClick={() =>
                window.open(
                  'https://slan-tech.feishu.cn/wiki/SpWLwtOVVifUd8k9AVmcKZvAnTd',
                  '_blank'
                )
              }
            />
          </Tooltip>
        </li>
        {userInfo && (
          <li>
            <Dropdown droplist={droplist} position="br" disabled={userLoading}>
              <Avatar size={32} style={{ cursor: 'pointer' }}>
                {userLoading ? (
                  <IconLoading />
                ) : (
                  <img alt="avatar" src={avatarUrl} />
                )}
              </Avatar>
            </Dropdown>
          </li>
        )}
      </ul>
    </div>
  );
}

export default Navbar;
